// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-thumbnail {
  width: 135px;
  height: 100%;
}
:host .movie {
  display: flex;
  position: relative;
}
:host .play_button {
  position: absolute;
  width: 75px;
  height: 50px;
  background: red;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:host .play_button .play_icon {
  width: 32px;
  height: 32px;
  border-left: 32px solid white;
  border-bottom: 16px solid transparent;
  border-top: 16px solid transparent;
  margin-left: 24px;
  margin-top: 9px;
}
:host .videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}
:host .videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-animation-list6/custom-animation-list6.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,kBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,qCAAA;EACA,kCAAA;EACA,iBAAA;EACA,eAAA;AAFN;AAKE;EACE,kBAAA;EACA,sBAAA,EAAA,SAAA;EACA,iBAAA;EACA,SAAA;AAHJ;AAKA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAHJ","sourcesContent":[":host {\n  ion-thumbnail {\n    width: 135px;\n    height: 100%;\n  }\n\n  .movie {\n    display: flex;\n    position: relative;\n  }\n\n  .play_button {\n    position: absolute;\n    width: 75px;\n    height: 50px;\n    background: red;\n    border-radius: 10px;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n\n    .play_icon {\n      width: 32px;\n      height: 32px;\n      border-left: 32px solid white;\n      border-bottom: 16px solid transparent;\n      border-top: 16px solid transparent;\n      margin-left: 24px;\n      margin-top: 9px;\n    }\n  }\n  .videoWrapper {\n    position: relative;\n    padding-bottom: 56.25%; /* 16:9 */\n    padding-top: 25px;\n    height: 0;\n}\n.videoWrapper iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
